import { StoreModelType, StoreModelDate } from '@aksia/infrastructure';
import {
  CarriedInterestRateTypeEnum,
  CarriedInterestTieredBaseEnum,
  PrefReturnEnum,
  WaterfallEnum,
  ClawbackGuaranteeEnum,
} from '../../enums/closedEnd.enum';
import {
  CurrencyEnum,
  SimpleAnswerEnum,
  MgmtFeeFrequencyEnum,
} from '../../enums/entity.enum';
import {
  MgmtFeePeriod,
  ClosedMgmtFeeDiscount,
  CarriedInterestTieredRate,
  CarriedInterestDiscount,
} from '../entities/entities.model';
import { IShareClass } from '../../interfaces/shareclass/shareclass.interface';
import { IClosedShareClass } from '../../interfaces/shareclass/shareclass.closed.interface';
import { ShareClass } from './shareclass';

export class ClosedShareClass
  extends ShareClass
  implements IShareClass, IClosedShareClass
{
  classType?: string = 'ClosedShareClass';

  //#region <<< Section - Minimum Investment >>>

  minimumLPCommitment?: number = undefined;
  minimumLPCommitmentCurrency?: CurrencyEnum = undefined;

  //#endregion

  //#region <<< Section - Management Fee >>>

  mgmtFee?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => StoreModelDate)
  mgmtFeeCeasedOn?: Date = undefined;

  @StoreModelType(() => MgmtFeePeriod)
  mgmtFeePeriods?: Array<MgmtFeePeriod> = undefined;
  paymentFrequency?: MgmtFeeFrequencyEnum = undefined;
  paymentFrequencyDescription?: string;
  mgmtFeeOffsetRate?: number = undefined;
  hasMgmtFeeDiscounts?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => ClosedMgmtFeeDiscount)
  mgmtFeeDiscounts?: Array<ClosedMgmtFeeDiscount> = undefined;

  //#endregion

  //#region <<< Section - Carried Interest >>>

  carriedInterest?: SimpleAnswerEnum = undefined;
  carriedInterestRateType?: CarriedInterestRateTypeEnum = undefined;
  carriedInterestTieredBaseType?: CarriedInterestTieredBaseEnum = undefined;

  @StoreModelType(() => CarriedInterestTieredRate)
  carriedInterestTieredRates?: Array<CarriedInterestTieredRate> = undefined;
  carriedInterestRate?: number = undefined;
  carriedInterestPrefReturnType?: PrefReturnEnum = undefined;
  carriedInterestPrefReturnRate?: number = undefined;
  carriedInterestCatchUpRate?: number = undefined;
  carriedInterestWaterfall?: WaterfallEnum = undefined;
  carriedInterestWaterfallDesc?: string = undefined;
  carriedInterestWaterfallFairValueTest?: number = undefined;
  gpClawback?: SimpleAnswerEnum = undefined;
  interimCalculations?: SimpleAnswerEnum = undefined;
  escrowAccount?: SimpleAnswerEnum = undefined;
  escrowAccountRate?: number = undefined;
  clawbackGuaranteeType?: ClawbackGuaranteeEnum = undefined;
  hasCarriedInterestDiscounts?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => CarriedInterestDiscount)
  carriedInterestDiscounts?: Array<CarriedInterestDiscount> = undefined;

  //#endregion

  //#region <<< Section - Discounts >>>

  hasFirstCloseDiscount?: SimpleAnswerEnum = undefined;
  hasSizeThresholdDiscount?: SimpleAnswerEnum = undefined;
  hasOtherDiscount?: SimpleAnswerEnum = undefined;

  //#endregion

  constructor() {
    super();
    this.className = 'Default Class';
  }
}
